/**
 * Model Catalog Page (Track B-4)
 * Read-only view of the unified model catalog (GET /v1/admin/models/catalog).
 */

import { ModelCatalogPanel } from '@/features/model-catalog/ModelCatalogPanel';

export function ModelCatalogPage() {
  return <ModelCatalogPanel />;
}

export default ModelCatalogPage;
